import { Head, router } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { foundingMemberCreatorPath, foundingMemberCreatorSkipPath } from "@travily/routes";
import type { AccountType } from "@/components/AccountTypeCard/AccountTypeCard";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { FoundingMemberCreatorShowView } from "./show.view";

const FoundingMemberSetupPage = () => {
  const handleSelectType = (type: AccountType) => {
    router.post(foundingMemberCreatorPath(), { member_type: type });
  };

  const handleSkipToWaitlist = () => {
    router.post(foundingMemberCreatorSkipPath());
  };

  const topBarActions = useCreatorTopBarActions({ onFinishLater: handleSkipToWaitlist });

  return (
    <>
      <Head title={t("web.founding_members.creator.show.meta_title")}>
        <meta name="description" content={t("web.founding_members.creator.show.meta_description")} />
      </Head>
      <FoundingMemberCreatorShowView onSelectType={handleSelectType} topBarActions={topBarActions} />
    </>
  );
};

export default FoundingMemberSetupPage;
